const defaultSource = [
  "loan.loanDetailId.originatorPartyId",
  "loan.loanType",
  "loan.actualLoanType",
  "loan.loanInfo.toorakProduct",
  "loan.loanDetailId.isWarehouseFunded",
  "loan.loanDetailId.fundingType",
  "loan.loanProcessType",
  "loan.loanTypeId.loanTypeName",
  "loan.onHoldBy",
  "loan.loanCredit.phase1ClosingDate",
  "loan.loanInfo.primaryLoanId",
  "loan.loanInfo.takeoutPartner",
  "onHoldDetails",
  "loan.loanDetailId.loanLandmarks",
  "loan.loanStage",
  "loan.loanDetailId.loanSummaryId.reconciledWithWells",
  "loan.loanDetailId.loanSummaryId.reconciledWithTpr",
  "loan.loanDetailId.loanSummaryId.reconciledWithServicer"
];
const borrowersGuarantorsSource = [
  "loan.loanUserMap",
  "guarantors",
  "borrowers"
];

export const columnSourceMap: { [key: string]: string | string[] } = {
  toorakLoanId: ["loan.loanDetailId.loanId", ...defaultSource], // mandatory field
  loanTypeName: [
    "loan.loanType",
    "loan.actualLoanType",
    "loan.loanInfo.toorakProduct",
    "loan.loanDetailId.isWarehouseFunded",
    "loan.loanDetailId.fundingType",
    "loan.loanProcessType",
    "loan.loanTypeId.loanTypeName"
  ],
  riskBucket: "result.loanResult.riskScores.riskBucket",
  needEnhancedReview:
    "result.loanResult.loanCharacterisations.needEnhancedReview",
  address: "properties",
  status: ["loan.loanState", "bundle.bundleStatus"],
  originalLoanId: "loan.loanInfo.primaryLoanId",
  activeInteractions: [
    "pendingAllWaiverCount",
    "pendingExternalWaiverCount",
    "pendingAllExceptionCount",
    "pendingExternalExceptionCount",
    "pendingAllEnquiryCount",
    "pendingExternalEnquiryCount",
    "currentPendingAllWaiverCount",
    "currentPendingExternalWaiverCount",
    "currentPendingAllExceptionCount",
    "currentPendingExternalExceptionCount",
    "currentPendingAllEnquiryCount",
    "currentPendingExternalEnquiryCount"
  ],
  toorakTradeID: "loan.loanDetailId.tradeId",
  loanStage: "loan.loanStage",
  firstPostedOpenCondt: "firstOpenConditionDate",
  propertyType: "properties",
  toorakLoanTypeRehab:
    "result.loanResult.loanCharacterisations.loanCharacterisation",
  loanCreateDate: "loan.loanCreationDate",
  loanPurpose: "loan.loanInfo.loanPurpose",
  firstName: [...borrowersGuarantorsSource],
  lastName: [...borrowersGuarantorsSource],
  loanSubmissionDate: "loan.loanSubmissionDate",
  initialLoanSubmissionDate: "loan.initialLoanSubmissionDate",
  effectiveStartDate: "loan.loanDetailId.loanConfigId.rateLockedRateSheet",
  rateLockExpiryDate: [
    "loan.rateLockExpiryDate",
    "loan.sizerRateLockExpiryDate"
  ],
  rateLockRequestedDate: "loan.loanDetailId.rateLocks.created_on",
  rateLockStatus: "loan.loanDetailId.rateLocks.rateLockStatus",
  rateLockUpdatedDate: "loan.loanDetailId.rateLocks.updated_on",
  initialPipelineSubmissionDate: "loan.initialPipelineSubmissionDate",
  updatedOn: "updatedOn",
  originator: "originator.accountName",
  loanCreatedBy: "loan.loanCreatedBy",
  loanAmount: "loan.loanEconomics.originalLoanAmount",
  interestRate: "loan.loanEconomics.interestRateAsOfCutOffDate",
  numberOfProperties: "loan.loanInfo.noOfProperties",
  originationDate: "loan.loanInfo.originationDate",
  foreignNationalString: "borrowerDetails.customer.foreignNationalString",
  experiance: [
    ...borrowersGuarantorsSource,
    "borrowerDetails.loanUser.experience",
    "borrowerDetails.loanUser.borrowerGUCExperience",
    "borrowerDetails.loanUser.heavyRehabExperience"
  ],
  originalCreditScoreMedian:
    "result.loanResult.borrowerInfo.originalCreditScoreMedian",
  originalCreditScoreReportDate:
    "result.loanResult.borrowerInfo.originalCreditScoreReportDate",
  primaryEmail: [...borrowersGuarantorsSource],
  borrowerBillingPhone: [...borrowersGuarantorsSource],
  numberOfGuarantors: "numberOfGuarantors",
  loanStructure: "loan.loanInfo.loanStructure",
  additionalGuarantorName: [...borrowersGuarantorsSource],
  cutOffDate: "loan.loanInfo.cutOffDate",
  firstPaymentDateOfLoan: "loan.loanInfo.firstPaymentDateOfLoan",
  originalMaturityDate: "loan.loanInfo.originalMaturityDate",
  hasExtensions: "loan.loanInfo.hasExtensions",
  currentMaturityDate: "loan.loanInfo.currentMaturityDate",
  interestRatePriorToOriginationInTc:
    "loan.loanInfo.interestRatePriorToOriginationInTc",
  recourseString: "loan.loanInfo.recourseString",
  crossCollaterlization: "loan.loanInfo.crossCollaterlization",
  collateralLoanId: "loan.loanInfo.collateralLoanId",
  extensionOptions: "loan.loanInfo.extensionOptions",
  financedInterestReserve: "loan.loanEconomics.financedInterestReserve",
  originalMaximumLoanAmount: "loan.loanEconomics.originalMaximumLoanAmount",
  takeoutPartner: [
    "loan.loanInfo.takeoutPartner",
    "loan.loanInfo.takeoutPartnerStatus"
  ],
  finalToorakYield: "result.loanResult.toorakInterests.finalToorakYield",
  pricingDiscount: "result.loanResult.toorakInterests.pricingDiscount",
  cutOffDateLoanAmount: "loan.loanEconomics.cutOffDateLoanAmount",
  cutOffDateMaximumLoanAmount: "loan.loanEconomics.cutOffDateMaximumLoanAmount",
  accrualType: "loan.loanEconomics.accrualType",
  totalOriginationAndDiscountPoints:
    "result.loanResult.loanEconomics.totalOriginationAndDiscountPoints",
  totalBudgetAmount: "loan.loanEconomics.totalBudgetAmount",
  cashOutAmount: "loan.loanEconomics.cashOutAmount",
  financedBudgetAmount: [
    "result.loanResult.loanEconomics.financedBudgetAmountCalculated",
    "loan.loanEconomics.financedBudgetAmount"
  ],
  appraisalReportedNoiNcf: "properties",
  lifeRateCap: "loan.loanEconomics.lifeRateCap",
  purchasePrice: "properties",
  dateUploaded: "loan.loanDetailId.loanConfigId.dateUploaded",
  dueDiligencePartyId: "loan.loanDetailId.loanConfigId.dueDiligencePartyId",
  ddReportStatus: "loan.ddReportStatus",
  teamIndiaTapetoFile: "loan.loanDetailId.loanSummaryId.teamIndiaTapetoFile",
  preCloseDocReview: "loan.loanDetailId.loanSummaryId.preCloseDocReview",
  tapeToFile: "loan.loanDetailId.loanConfigId.tapeToFile",
  truliaCrime: "loan.loanDetailId.loanConfigId.truliaCrime",
  zillow: "loan.loanDetailId.loanConfigId.zillow",
  emailSentToOriginator: "loan.loanDetailId.loanConfigId.emailSentToOriginator",
  streetView: "loan.loanDetailId.loanConfigId.streetView",
  appraisal: "loan.loanDetailId.loanConfigId.appraisal",
  closingDate: "bundle.closingDate",
  postRehabSquareFootage: "properties",
  preRehabSquareFootage: "properties",
  originalAsRepairedAppraisedValue: [
    "properties",
    "results.propertiesResults.loanFeatures.originalArvValueForCalculation"
  ],
  financedAsRepairedAppraisedValue:
    "results.propertiesResults.loanFeatures.arvValueForCalculation",
  insurance: "properties",
  grossPotentialRent: "properties",
  changeInUseCase: "properties",
  propertyAcquisitionDate: "properties",
  originalAsIsAppraisalValue: [
    "properties",
    "results.propertiesResults.loanFeatures.originalAsIsValueForCalculation"
  ],
  financedAsIsAppraisalValue:
    "results.propertiesResults.loanFeatures.asIsValueForCalculation",
  propertyUnits: "properties",
  recentPropertyValuationDate: "properties",
  costBasis: "properties",
  annualPropertyTaxes: "properties",
  occupiedPercentage: "properties",
  subsequentPeriodicCap: "loan.loanEconomics.subsequentPeriodicCap",
  squareFootage: "properties",
  rentDescription: "properties",
  rateType: "loan.loanEconomics.rateType",
  prepaymentPenaltyMonths: "loan.loanEconomics.prepaymentPenaltyMonths",
  prepayPenaltyType: "loan.loanEconomics.prepayPenaltyType",
  rateAdjustmentFrequency: "loan.loanEconomics.rateAdjustmentFrequency",
  paymentAdjustmentFrequency: "loan.loanEconomics.paymentAdjustmentFrequency",
  originalMonthlyPiPayment: "loan.loanEconomics.originalMonthlyPiPayment",
  interestOnlyPeriod: "loan.loanEconomics.interestOnlyPeriod",
  initialRateAdjustmentPeriod: "loan.loanEconomics.initialRateAdjustmentPeriod",
  initialPeriodicCap: "loan.loanEconomics.initialPeriodicCap",
  initialPayAdjustmentPeriod: "loan.loanEconomics.initialPayAdjustmentPeriod",
  grossArmMargin: "loan.loanEconomics.grossArmMargin",
  debtServiceCoverageRatio: "result.loanResult.loanEconomics.dscr",
  currentLoanBalance:
    "result.loanResult.loanEconomics.currentLoanBalanceAmount",
  currentLoanBalanceAmount:
    "result.loanResult.loanEconomics.currentLoanBalanceAmount",
  costToLoanRatio: "loan.loanEconomics.costToLoanRatio",
  originalLtc: "result.loanResult.loanFeatures.originalLtc",
  originalAsIsLtv: "result.loanResult.loanFeatures.originalAsIsLtv",
  originalAsRepairedLtv: "result.loanResult.loanFeatures.originalAsRepairedLtv",
  hcValue95: "result.loanResult.loanFeatures.hcValue95",
  hcValueMedian: "result.loanResult.loanFeatures.hcValueMedian",
  varianceHcValue95: "result.loanResult.loanFeatures.varianceHcValue95",
  varianceHcValueMedian: "result.loanResult.loanFeatures.varianceHcValueMedian",
  finalToorakPrice: "result.loanResult.loanPricing.finalToorakPrice",
  annualHazardInsurance: "properties",
  ARMIndex: "loan.loanEconomics.armIndex",
  annualMarketRent: "properties",
  annualHoaFee: "properties",
  annualFloodInsurance: "properties",
  ownershipOfEntity: [...borrowersGuarantorsSource],
  borrowerType: [...borrowersGuarantorsSource],
  borrowerBillingAddress: [...borrowersGuarantorsSource],
  borrowingEntityName: [...borrowersGuarantorsSource],
  lifetimeMaxRate: "loan.loanEconomics.lifetimeMaxRate",
  monthlyTaxAmount: "result.loanResult.loanEconomics.monthlyTaxAmount",
  monthlyInsuranceAmount:
    "result.loanResult.loanEconomics.monthlyInsuranceAmount",
  taxes: "loan.loanDetailId.loanSummaryId.taxes",
  taxesandInsuranceDue: "loan.loanDetailId.loanSummaryId.taxesandInsuranceDue",
  escrowFund: "loan.loanDetailId.loanSummaryId.escrowFund",
  lastPaymentDate: "loan.loanDetailId.loanSummaryId.lastPaymentDate",
  nextPaymentDueDate: "loan.loanDetailId.loanSummaryId.nextPaymentDueDate",
  updatedEscrowBalance: "loan.loanDetailId.loanSummaryId.updatedEscrowBalance",
  seasoned: "loan.loanDetailId.loanSummaryId.seasoned",
  paymentHistoryandUPBChecked:
    "loan.loanDetailId.loanSummaryId.paymentHistoryandUPBChecked",
  firstLoss: "result.loanResult.firstLoss.firstLossPercentage",
  holdback: "result.loanResult.firstLoss.totalCreditReserveHoldback",
  riskScore: [
    "result.loanResult.riskScores.totalAggregateRisk",
    "result.loanResult.riskScores.riskScoresVersion"
  ],
  inStateLocRisk: [
    "result.loanResult.riskScores.inStateLocRisk",
    "result.loanResult.riskScoreCalculations.inState",
    "result.loanResult.riskScores.riskScoresVersion"
  ],
  spoc: ["spocPartyInfo.fullName"],
  leaseStatus: "properties",
  lendingAmount: "lendingAmount",
  grade: "grades",
  master: "loan.loanDetailId.loanConfigId",
  fico: "result.loanResult.warehouseLine.fico",
  rateLocked: "loan.rateLockSyncStatus",
  rateLockedDate: "loan.loanDetailId.loanConfigId.rateLockedDate",
  servicerLoanId: "onboardingData.servicerLoanId",
  debtYield: "result.loanResult.creditEvaluation.actualDebtYield",
  enhancedReview: "loan.loanDetailId.loanSummaryId.enhancedReview",
  dataReconcilationStatus:
    "loan.loanDetailId.loanSummaryId.dataReconcilationStatus",
  reconciledWithWells: "loan.loanDetailId.loanSummaryId.reconciledWithWells",
  reconciledWithTpr: "loan.loanDetailId.loanSummaryId.reconciledWithTpr",
  reconciledWithServicer:
    "loan.loanDetailId.loanSummaryId.reconciledWithServicer",
  reconciledWithWellsDiscrepancyCount:
    "loan.loanDetailId.loanSummaryId.discrepanciesCountWithWells",
  reconciledWithServicerDiscrepancyCount:
    "loan.loanDetailId.loanSummaryId.discrepanciesCountWithServicer",
  discrepanciesCount: "loan.loanDetailId.loanSummaryId.discrepanciesCount", // TPR count
  toorakYield: "result.loanResult.toorakInterests.toorakYield",
  collateral: "loan.loanDetailId.loanConfigId.collateral",
  dscrCheckBox: "loan.loanDetailId.loanConfigId.dscrCheckBox",
};
